/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {InputModule} from '../../shared/input/input.module';
import {PartNumberChangesOldCredentialsComponent} from './part-number-changes-old-credentials.component';
import {PartNumberChangesRejectMotivationModule} from './part-number-changes-reject-motivation/part-number-changes-reject-motivation.module';
import {PncLotNumberInputModule} from './pnc-lot-number-input/pnc-lot-number-input.module';
import {PartNumberChangesAdditionalInputModule} from '../shared/part-number-changes-additional-input/part-number-changes-additional-input.module';
import {PartNumberChangesAdditionalSpoNumberModule} from './part-number-changes-additional-spo-number/part-number-changes-additional-spo-number.module';

@NgModule({
    declarations: [PartNumberChangesOldCredentialsComponent],
    imports: [
        CommonModule,
        PipesModule,
        InputModule,
        PartNumberChangesRejectMotivationModule,
        PncLotNumberInputModule,
        PartNumberChangesAdditionalInputModule,
        PartNumberChangesAdditionalSpoNumberModule
    ],
    exports: [
        PartNumberChangesOldCredentialsComponent
    ]
})
export class PartNumberChangesOldCredentialsModule {
}
